module.exports = __webpack_public_path__ + "static/media/header6.9923c76a.webp";